<script>
import {
  shippingMethodLddEmits,
  shippingMethodLddProps,
  useShippingMethodLdd
} from "./mixin";

import AddressLadSelector from "@/containers/adresses-lad/adress-lad-selector";
import AddressLadForm from "@/containers/adresses-lad/addresse-lad-form";
import Popin from "@/components/molecules/popin";
import InfoComplementaires from "@/containers/shipping-method/shipping-method-ldd/info-complementaires";

export default {
  name: "ShippingMethodLad",
  components: {
    AddressLadSelector,
    AddressLadForm,
    Popin,
    InfoComplementaires
  },
  props: {
    ...shippingMethodLddProps()
  },
  emits: [...shippingMethodLddEmits()],
  setup(props, context) {
    const { updateModeCommande } = useShippingMethodLdd(context);
    return { updateModeCommande };
  },
  data() {
    return {
      addresseId: null
    };
  },
  methods: {
    showAddAdress() {
      this.$refs.popinAddAddress.show();
    },
    editAddress(id) {
      this.addresseId = id;
      this.$refs.popinAddAddress.show();
    },
    addresseLadSaved() {
      this.$refs.addressLadSelector.refresh();
      this.$refs.popinAddAddress.hide();
    }
  }
};
</script>

<template>
  <div class="u-pt-sm u-pl-md u-pr-md u-pb-md">
    <AddressLadSelector
      ref="addressLadSelector"
      :check-eligibilite="false"
      @addAddress="showAddAdress()"
      @editAddress="editAddress"
    />

    <template v-if="addresseLad">
      <InfoComplementaires
        :addresse-lad="addresseLad"
        :infos-legales="service.info_non_retrait"
        @updateModeCommande="updateModeCommande"
      />
    </template>
    <Popin
      ref="popinAddAddress"
      size="lg"
      aria-label="Adresse de livraison"
      @hidden="addresseId = null"
    >
      <h1 class="u-font-24 u-text-center u-color-primary u-mb-lg u-mb-none@sm u-p-sm@sm">
        <template v-if="!addresseId">
          Ajouter une adresse de livraison
        </template>
        <template v-else>
          Modifier une adresse de livraison
        </template>
      </h1>

      <AddressLadForm
        :addresse-id="addresseId"
        :check-eligibilite="false"
        @cancel="$refs.popinAddAddress.hide()"
        @saved="addresseLadSaved()"
      />
    </Popin>
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/styles/components/schedule.scss";
</style>
